import { Link, NavLink } from 'react-router-dom';

export function Header() {

    return (
        <nav className="navbar navbar-expand-sm navbar-dark bg-transparent p-0">
            <div className="container-fluid px-0">
                <Link className="navbar-brand p-0 m-0" to="/">
                    <div className="bg-white text-115 text-dark py-1 px-3 text-avenir-db">NFTY</div>
                </Link>
                <div className="ms-auto collapse navbar-collapse">
                    <div className="ms-auto navbar-nav bg-darker">
                        <NavLink className="nav-link mx-3" exact to="/">Home</NavLink>
                        <NavLink className="nav-link me-3" to="/artists">Artists</NavLink>
                        <NavLink className="nav-link me-3" to="/about">What?</NavLink>
                    </div>
                </div>
            </div>
        </nav>
    );
}